// Navigation bar component

import { Link, useLocation } from 'react-router-dom';

interface NavbarProps {
  onAskAiClick: () => void;
}

export function Navbar({ onAskAiClick }: NavbarProps) {
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass border-b border-border/30">
      <div className="container-custom">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <span className="text-xl font-serif font-semibold text-text-primary">
              XAVIER PINEDA
            </span>
            <span className="hidden sm:block w-px h-6 bg-accent" />
          </Link>

          {/* Navigation Links */}
          <div className="flex items-center gap-1 sm:gap-2">
            <Link
              to="/"
              className={`btn-ghost text-sm ${
                isActive('/') ? 'text-accent' : ''
              }`}
            >
              Home
            </Link>
            <Link
              to="/experience"
              className={`btn-ghost text-sm ${
                isActive('/experience') ? 'text-accent' : ''
              }`}
            >
              Experience
            </Link>
            <Link
              to="/fit-check"
              className={`btn-ghost text-sm ${
                isActive('/fit-check') ? 'text-accent' : ''
              }`}
            >
              Fit Check
            </Link>

            {/* Ask AI Button */}
            <button
              onClick={onAskAiClick}
              className="btn-primary text-sm ml-2 relative"
            >
              <span className="flex items-center gap-2">
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                  />
                </svg>
                Ask AI
              </span>
              <span className="absolute -top-1 -right-1 px-1.5 py-0.5 text-xs bg-success text-white rounded-full">
                New
              </span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
